import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { PrimaryButton } from '../../../../../../../../components/Button/ActionButtons';
import { StyledTextField } from '../../../../../../../../components/Inputs';
import useSessionStore from '../../../../../../../../hooks/useSessionStore';
import useUserDoc from '../../../../../../../hooks/useUserDoc';
import { LeadHistoryType } from '../../../../../../../Model/Lead';

import { StyledAddIcon, ButtonContainer } from './styles';
import texts from './texts.json';

const LogActivity = ({ lead }) => {
  const [note, setNote] = useState('');
  const [error, setError] = useState('');

  const { userId } = useSessionStore();
  const { isReady, userDoc } = useUserDoc(userId);

  const createNote = async () => {
    if (!note) {
      setError(texts.error);
      return;
    }
    if (isReady) {
      await lead.addItemToHistory({
        value: note,
        createdAt: new Date(),
        activityType: LeadHistoryType.NOTE,
        createdBy: userId,
        createdByUserName: userDoc.name,
      });
      setNote('');
    }
  };

  return (
    <ButtonContainer>
      <StyledTextField
        multiline
        rows={2}
        fullWidth
        value={note}
        onChange={(e) => setNote(e.target.value)}
        error={!!error}
        helperText={error}
        placeholder={texts.notePlaceholder}
      />
      <PrimaryButton
        onClick={createNote}
        size="large"
        variant="light"
        icon={<StyledAddIcon />}
      >
        {texts.logActivity}
      </PrimaryButton>
    </ButtonContainer>
  );
};

LogActivity.propTypes = {
  lead: PropTypes.object.isRequired,
};

export default LogActivity;
